export default __webpack_public_path__ + "static/media/Pm.089a11bc.jpg";